(function(){
    'use strict'

    angular.module('app.deducibles')
    .factory('DeduciblesService', DeduciblesService);

    DeduciblesService.$inject = ['$http', '$q', 'apiSettings'];

    function DeduciblesService($http, $q, apiSettings) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            update:update,
            remove: remove,
            getAllOtros: getAllOtros,
            getByIdOtros: getByIdOtros,
            saveOtros: saveOtros,
            updateOtros:updateOtros,
            removeOtros: removeOtros
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/deducciones';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(deducibleId){

            var url = apiSettings.apiBaseUrl + 'api/deducciones/' + deducibleId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(deducible){

            deducible.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/deducciones',  
                method: 'POST',  
                data: deducible
            });  
            return response;
        };

        function update(deducible){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/deducciones',  
                method: 'PUT',  
                data: deducible
            });  
            return response;
        };

        function remove(deducible){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/deducciones',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: deducible
            });  
            return response;
        };

        function getAllOtros(){

            var url = apiSettings.apiBaseUrl + 'api/otras-deducciones';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getByIdOtros(deducibleId){

            var url = apiSettings.apiBaseUrl + 'api/otras-deducciones/' + deducibleId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function saveOtros(deducible){

            deducible.id = 0;

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/otras-deducciones',  
                method: 'POST',  
                data: deducible
            });  
            return response;
        };

        function updateOtros(deducible){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/otras-deducciones',  
                method: 'PUT',  
                data: deducible
            });  
            return response;
        };

        function removeOtros(deducible){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/otras-deducciones',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: deducible
            });  
            return response;
        };

    };

})();        